// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"14":"9381f1ad","248":"c490048b","274":"c47018a1","320":"ca43599f","328":"e243ca86","331":"48da1395","488":"b5d260cb","783":"ee8ee626","794":"8079f501","831":"d269ab07"}[chunkId] + ".chunk.js";
};